import {observer} from "mobx-react";
import {FieldDate} from "../../../ui";
import {registrationStore, registrationValidationStore} from "../../../../store";

function addWorkingDaysFromToday(workingDays: number): Date {
    const result = new Date();
    let added = 0;
    while (added < workingDays) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 0 && day !== 6) {
            added++;
        }
    }
    return result;
}

const DesignatedRegistrationDatePanel = observer(function DesignatedRegistrationDatePanel() {
    const minDate = addWorkingDaysFromToday(3);
    const maxDate = addWorkingDaysFromToday(12);

    const formatDate = (date: Date) =>
        date.toISOString().split("T")[0];
    const dateHelp = registrationValidationStore.getFor("designatedRegistrationDate")

    return <nav className="panel">
        <p className="panel-heading">Zulassungsdatum</p>
        <div className="panel-block">
            <div className="is-flex" style={{"flex":1}}>
                    <label className={"checkbox is-align-content-center"}>
                        <input disabled={registrationStore.isReadonly} type={"checkbox"}
                               checked={Boolean(registrationStore.isDesignatedRegistrationDate)}
                               onChange={e => {
                                   registrationStore.isDesignatedRegistrationDate = e.target.checked
                               }}/>
                    </label>
                    <FieldDate disabled={!Boolean(registrationStore.isDesignatedRegistrationDate)
                                            || registrationStore.isReadonly}
                               id={'designated-registration-date'}
                               value={registrationStore.designatedRegistrationDate}
                               onChange={v => registrationStore.designatedRegistrationDate = v}
                               onBlur={() => registrationStore.validate()}
                               required={true}
                               earliest={formatDate(minDate)}
                               latest={formatDate(maxDate)}
                               help={dateHelp}
                               invalid={Boolean(dateHelp)}
                    />
            </div>
        </div>
    </nav>
})

export {
    DesignatedRegistrationDatePanel
}
